export const BackToSourceColumn=[
    {
      accessor:"row",
      Header: "ردیف",
    },
    {
      accessor: "serialNumber",
      header: "شماره مرسوله",
    },
    {
      accessor: "ReceiverName",
      header: "نام گیرنده",
    },

    {
      accessor: "operation",
      header: "عملیات",
    },
  ]